const scrollToTop = () => {
    if (window && window.scroll) {
        window.scroll(0, 0);
    }
};

export default {scrollToTop};


// WEBPACK FOOTER //
// ./src/universal/utils/dom.js